// @flow

import * as React from 'react';

import {
  Select as BaseSelect,
  type SelectProps,
  Menu as BaseMenu,
  type MenuProps,
  TokenListInput as BaseTokenListInput,
  type TokenListInputProps,
  StringListInput as BaseStringListInput,
  type StringListInputProps,
  CustomTokenListInput as BaseCustomTokenListInput,
  type CustomTokenListInputProps,
} from './new-stuff.jsx';
import css from './borderless.css';


export function Select<V>(props: SelectProps<V>): React.Node {
  return <BaseSelect baseClassNames={css} {...props} />;
}

export function Menu<V, O>(props: MenuProps<V, O>): React.Node {
  return (
    // $FlowFixMe[incompatible-type] definitely need to resolve this
    <BaseMenu baseClassNames={css} {...props} />
  );
}

export function TokenListInput<V>(props: TokenListInputProps<V>): React.Node {
  return <BaseTokenListInput baseClassNames={css} {...props} />;
}

export function StringListInput(props: StringListInputProps): React.Node {
  return <BaseStringListInput baseClassNames={css} {...props} />;
}

export function CustomTokenListInput(
  props: CustomTokenListInputProps,
): React.Node {
  return <BaseCustomTokenListInput baseClassNames={css} {...props} />;
}
